import ViewLocation from './ViewLocationContainer';

export default ViewLocation;
